import { StackProps } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import {
  Event,
  SellerEventMarketplaceEventInfo,
  Venue,
} from 'src/WebApiController';

export enum EventHeaderMetricsType {
  Summary = 'summary',
  Stats = 'stats',
}

export type EventHeaderMetrics = {
  label: ContentId;
  value: React.ReactNode;
  direction?: 'column' | 'row';
  tooltip?: React.ReactNode;
};

export type EventHeaderSumarryMetrics = {
  type: EventHeaderMetricsType.Summary;
  metrics: EventHeaderMetrics;
};

export type EventHeaderStatMetrics = {
  type: EventHeaderMetricsType.Stats;
  stats: EventHeaderMetrics[];
};

export type EventHeaderMetricsWithMarketplacesProps = {
  event: Event;
  venue?: Venue;
  marketplaceEventInfo?: SellerEventMarketplaceEventInfo[];
  onRefetchMarketplaceEventInfo?: () => void;
  metrics: EventHeaderSumarryMetrics | EventHeaderStatMetrics;
} & Pick<StackProps, 'justifyContent' | 'gap' | 'className'>;
